import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../common/GlobalReportPage';
import { GlobalMissingAudiosReportView } from './GlobalMissingAudiosReportView';

type Props = Record<string, never>;

export function MissingAudiosReportPage(p: Props) {
  const { $t } = useIntl();

  return (
    <BaseGlobalReportPage
      title={$t({
        id: 'audit.missingAudios.title',
        defaultMessage: 'Archivos faltantes',
      })}
    >
      <GlobalMissingAudiosReportView />
    </BaseGlobalReportPage>
  );
}
